export default {
  header: 'Beforehand, do you want to digitalize a paper stampcard?',
  buttons: {
    yes: 'Yes',
    no: 'No',
    skip: 'Skip',
  },
};
